import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {LinkLine} from '@dropbox/dig-icons/assets';

import {logWorkstreamsInteraction} from './workstreamsAnalytics';

/**
 * A collapsed group with no narrative of its own whose workstreams have some:
 * a subtle count, then a link icon the same size and spot as a row's own link
 * (NarrativeLinkIcon), so the icons line up down the rail. It isn't a link, so
 * a click opens the group to show the rows that carry them.
 */
export const NestedNarrativesHint = ({count, onExpand}: {count: number; onExpand: () => void}) => {
  const label = `${count} ${count === 1 ? 'narrative' : 'narratives'} inside`;
  return (
    <Box display="flex" alignItems="center">
      <Text size="small" color="subtle" aria-hidden>
        {count}
      </Text>
      <Tooltip title={label} placement="top">
        <IconButton
          variant="borderless"
          size="small"
          aria-label={label}
          // Opening the group shouldn't also select it (the row's own click).
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            logWorkstreamsInteraction('rail_group_toggled', {
              expanded: true,
              source: 'narrative_hint',
            });
            onExpand();
          }}
        >
          <UIIcon src={LinkLine} size="small" className={atoms({color: 'Text Subtle'})} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
